export default __webpack_public_path__ + "static/media/jrc_logo_main_white.15917743.ai";